import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight, Check, Minus, Plus, ShoppingCart, X } from "lucide-react";
import { PRODUCT_IMAGE } from "@/data";

const EASE = [0.22, 1, 0.36, 1];

export function CartDrawer({ open, cart, total, onClose, onQty, onCheckout }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div className="vf-overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose} data-testid="cart-overlay">
          <motion.aside className="vf-drawer" initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }} transition={{ duration: 0.45, ease: EASE }} onClick={(e) => e.stopPropagation()}>
            <div className="vf-drawer-head">
              <div><span>Votre panier</span><h2>Vos articles</h2></div>
              <button onClick={onClose} data-testid="close-cart-button" aria-label="Fermer"><X size={20} /></button>
            </div>
            {cart.length === 0 ? (
              <div className="vf-empty"><ShoppingCart size={28} /><p>Votre panier est vide.</p></div>
            ) : (
              <>
                <div className="vf-drawer-items">
                  {cart.map((item) => (
                    <div className="vf-drawer-item" key={item.id}>
                      <img src={PRODUCT_IMAGE} alt={item.name} />
                      <div>
                        <b>{item.name}</b>
                        <span>{item.price} €</span>
                        <div className="vf-drawer-qty">
                          <button onClick={() => onQty(item.id, -1)} data-testid={`drawer-decrease-${item.id}`} aria-label="Diminuer"><Minus size={12} /></button>
                          <span>{item.quantity}</span>
                          <button onClick={() => onQty(item.id, 1)} data-testid={`drawer-increase-${item.id}`} aria-label="Augmenter"><Plus size={12} /></button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="vf-drawer-foot">
                  <div className="vf-drawer-total"><span>Sous-total</span><b>{total.toFixed(2).replace(".", ",")} €</b></div>
                  <button className="vf-cta" onClick={onCheckout} data-testid="checkout-button">Passer la commande <ArrowRight size={16} /></button>
                </div>
              </>
            )}
          </motion.aside>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export function CheckoutModal({ open, total, onClose, onSubmit, onPayCard }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div className="vf-overlay vf-overlay-center" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="checkout-modal">
          <motion.div className="vf-modal" initial={{ opacity: 0, y: 40, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 24, scale: 0.98 }} transition={{ duration: 0.4, ease: EASE }}>
            <button className="vf-modal-close" onClick={onClose} data-testid="close-checkout-button" aria-label="Fermer"><X size={19} /></button>
            <p className="vf-kicker">Dernière étape</p>
            <h2>Finaliser votre commande</h2>
            <form onSubmit={onSubmit} data-testid="checkout-form">
              <input name="name" placeholder="Nom complet" required data-testid="checkout-name-input" />
              <input name="email" type="email" placeholder="Adresse email" required data-testid="checkout-email-input" />
              <input name="phone" placeholder="Téléphone" required data-testid="checkout-phone-input" />
              <input name="address" placeholder="Adresse" required data-testid="checkout-address-input" />
              <div className="vf-form-row">
                <input name="postal" placeholder="Code postal" required data-testid="checkout-postal-input" />
                <input name="city" placeholder="Ville" required data-testid="checkout-city-input" />
              </div>
              <button className="vf-cta" type="button" onClick={(e) => { const form = e.currentTarget.closest("form"); if (form.reportValidity()) onPayCard(new FormData(form)); }} data-testid="pay-card-button">Payer par carte · {total.toFixed(2).replace(".", ",")} €</button>
              <button className="vf-cta-alt" type="submit" data-testid="submit-order-button">Commander sans paiement en ligne</button>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export function SuccessModal({ order, onClose }) {
  return (
    <AnimatePresence>
      {order && (
        <motion.div className="vf-overlay vf-overlay-center" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="success-modal">
          <motion.div className="vf-modal vf-success" initial={{ opacity: 0, y: 40, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 24 }} transition={{ duration: 0.4, ease: EASE }}>
            <div className="vf-success-check"><Check size={24} /></div>
            <p className="vf-kicker vf-kicker-center">Commande confirmée</p>
            <h2>Merci pour votre commande</h2>
            <p>Votre commande <b data-testid="order-number">{order.id}</b> est bien enregistrée. Nous vous contacterons rapidement pour confirmer la livraison.</p>
            <button className="vf-cta" onClick={onClose} data-testid="close-success-button">Continuer mes achats</button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
